module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic-BETA.3c5ed4d1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ThinItalic-BETA.woff2
// module id = 710
// module chunks = 21